export default "__VITE_ASSET__D7aIJsIa__"